module.exports = __webpack_public_path__ + "img/lambda-alert.16414e1c.svg";